import { useSelector } from 'react-redux';
import { useClientPagination } from '../helpers/hooks';
import { useEffect } from 'react';
import { InfiniteScrollObserver } from '../helpers/InfiniteScrollObserver';
import { selectFilteredPoints } from '../filters/advancedFiltersSelectors';
import { SearchIcon } from '@iconicicons/react';
import {
  selectAllNodes,
  selectInterconnectsAtPoints,
} from '../map/slice/mapSelectors';
import { BooleanStatus } from '../helpers/BooleanStatus';
import { differenceInDays } from '../utils/dateUtils';
import {
  FLOW_ACTIVITY_THRESHOLD,
  NOTICE_ACTIVITY_THRESHOLD,
} from '../filters/advancedFiltersSlice';
import { useFocusPoint } from '../hooks/useFocusPoint';

export const PointsTable = () => {
  const focusPoint = useFocusPoint();
  const points = useSelector(selectFilteredPoints);
  const nodes = useSelector(selectAllNodes);
  const interconnectsAtPoints = useSelector(selectInterconnectsAtPoints);

  const {
    slice: paginatedPoints,
    exhausted,
    getNext,
    reset,
  } = useClientPagination(points, 30);

  useEffect(() => {
    reset();
  }, [points]);

  return (
    <table className="table">
      <thead>
        <tr>
          <th>Location</th>
          <th>Location ID</th>
          <th>TSP</th>
          <th>Status</th>
          <th>Type</th>
          <th>Flow Direction</th>
          <th>Receipt Zone</th>
          <th>Delivery Zone</th>
          <th>Interconnects</th>
          <th>Capacity Components</th>
          {/* <th>Flow Activity</th> */}
          <th>Notice Components</th>
          {/* <th>Notice Activity</th> */}
        </tr>
      </thead>
      <tbody>
        {paginatedPoints.map((point) => {
          const isMapped = point.node !== null && point.node !== undefined;
          // const flow_activity = point.flow_activity
          //   ? differenceInDays(new Date(point.flow_activity), new Date()) <=
          //     FLOW_ACTIVITY_THRESHOLD
          //   : false;
          // const flow_activity_date = point.flow_activity
          //   ? new Date(point.flow_activity).toLocaleDateString()
          //   : 'N/A';

          // const notice_activity = point.notice_activity
          //   ? differenceInDays(new Date(point.notice_activity), new Date()) <=
          //     NOTICE_ACTIVITY_THRESHOLD
          //   : false;
          // const notice_activity_date = point.notice_activity
          //   ? new Date(point.notice_activity).toLocaleDateString()
          //   : 'N/A';
          return (
            <tr key={point.id}>
              <td>
                <div className="d-flex align-items-center">
                  <button
                    className="btn btn-light me-2"
                    disabled={!point.node}
                    style={{
                      opacity: 1,
                    }}
                    onClick={() => {
                      focusPoint(point.id);
                    }}
                  >
                    <SearchIcon />
                  </button>
                  <span>
                    <strong className="me-2">#{point.id}</strong>{' '}
                    {point.name || 'N/A'}
                  </span>
                </div>
              </td>
              <td>{point.loc_id ?? 'N/A'}</td>
              <td>{point.tsp_name}</td>
              <td>
                <BooleanStatus
                  value={isMapped}
                  trueText="Mapped"
                  falseText="Not Mapped"
                />
              </td>
              <td>{point.loc_type_ind}</td>
              <td>{point.dir_flo ?? 'N/A'}</td>
              <td>{point.receipt_zone_name}</td>
              <td>{point.delivery_zone_name}</td>
              <td>
                <BooleanStatus
                  value={interconnectsAtPoints[point.id]?.length > 0}
                />
              </td>
              <td>
                <BooleanStatus value={point.capacity_components?.length > 0} />
              </td>
              {/* <td>
                <BooleanStatus
                  value={flow_activity}
                  // trueText={flow_activity_date}
                  // falseText={flow_activity_date}
                />
              </td> */}
              <td>
                <BooleanStatus value={point.notice_components?.length > 0} />
              </td>
              {/* <td>
                <BooleanStatus
                  value={notice_activity}
                  // trueText={notice_activity_date}
                  // falseText={notice_activity_date}
                />
              </td> */}
            </tr>
          );
        })}
        <tr>
          <td colSpan="12">
            {!exhausted && <InfiniteScrollObserver onScrollIn={getNext} />}
          </td>
        </tr>
      </tbody>
    </table>
  );
};
